module.exports = function() {
  return new Worker(__webpack_public_path__ + "9b3116d5203001f0c892.worker.js");
};